import { Component, Prop, h, State } from '@stencil/core';
import { serviceNumber as defaultServiceNumber } from '../../utils/ttarp';
import { serviceNumberControl } from '../../utils/ttarp_control';
import { serviceNumberTest } from '../../utils/ttarp_test';
import { desktopBannerMessage, mobileBannerMessage } from '../../constants/constants';
import { setFeatureFlagsFromUrl, signaler } from '../../utils/signaler';

@Component({
  tag: 'ci-header',
  styleUrl: 'ci-header.scss',
})
export class CustominkHeader {
  @Prop() headerFlavor: 'default' | 'simple' = 'default';
  @Prop() serviceNumber: string;
  @Prop() serviceNumberControl: string = serviceNumberControl;
  @Prop() serviceNumberTest: string = serviceNumberTest;
  @Prop() mobileBannerMessage: string = mobileBannerMessage;
  @Prop() desktopBannerMessage: string = desktopBannerMessage;
  @Prop() signaler = signaler;
  @State() ttarpHeaderTest: boolean;
  @State() ttarpHeaderControl: boolean;
  @State() hasServiceNumber: boolean;
  @State() resolvedServiceNumber: string;
  @State() isDesktopView: boolean;

  async componentWillLoad() {
    this.hasServiceNumber = !!this.serviceNumber;
    this.resolvedServiceNumber = this.serviceNumber || defaultServiceNumber;

    setFeatureFlagsFromUrl(this.signaler);
    window.dispatchEvent(new Event('ciHeaderLoaded'));

    const ttarpHeaderFlag = await this.signaler.featureFlag('ttarp_header_v3');

    if (process.env.NODE_ENV === 'test') {
      // Ensure the feature flag is set to 'excluded' in test environment
      this.signaler.setFeatureFlag('ttarp_header_v3', 'excluded');
    }

    this.ttarpHeaderTest = ttarpHeaderFlag === 'test';
    this.ttarpHeaderControl = ttarpHeaderFlag === 'control';

    this.updateViewMode();
    window.addEventListener('resize', this.updateViewMode);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updateViewMode);
  }

  updateViewMode = () => {
    this.isDesktopView = window.innerWidth >= 1024;
  }

  render() {
    if (this.headerFlavor == 'simple') {
      return <simple-header serviceNumber={this.resolvedServiceNumber} />;
    } else {
      if (this.hasServiceNumber) {
        return (
          <default-header
            serviceNumber={this.resolvedServiceNumber}
            mobileBannerMessage={this.mobileBannerMessage}
            desktopBannerMessage={this.desktopBannerMessage}
          />
        );
      } else {
        if ((this.ttarpHeaderTest) && (window.innerWidth >= 1024)) {
          return (
            <default-header
              serviceNumber={this.serviceNumberTest}
              mobileBannerMessage={this.mobileBannerMessage}
              desktopBannerMessage={this.desktopBannerMessage}
            />
          );
        } else if ((this.ttarpHeaderControl) && (window.innerWidth >= 1024)) {
          return (
            <default-header
              serviceNumber={this.serviceNumberControl}
              mobileBannerMessage={this.mobileBannerMessage}
              desktopBannerMessage={this.desktopBannerMessage}
            />
          );
        } else {
          return (
            <default-header
              serviceNumber={this.resolvedServiceNumber}
              mobileBannerMessage={this.mobileBannerMessage}
              desktopBannerMessage={this.desktopBannerMessage}
            />
          );
        }
      }
    }
  }
}
